import React, { useRef } from 'react';
import { Modal as ReactModal } from 'react-native';
import { useOnClickOutside } from '../../../hooks/useOnClickOutside';
import { wrapperModalTestID } from 'src/helpers/testIDs.helper';
import { ModalBodyProps } from './modal-body/ModalBody.types';
import { DYNAMIC_MODAL_TYPES } from '../dynamic-modals/DynamicModal.types';
import { ModalFullscreenContainer } from './modal-fullscreen-container/ModalFullscreenContainer';
import { useStore } from 'src/contexts/StoreContext';
import { observer } from 'mobx-react-lite';
import { ModalBody } from './modal-body/ModalBody';

type ModalProps = {
  visible: boolean;
  onClose?: () => void;
  closeOnClickOutside?: boolean;
  isInstant?: boolean;
  type: DYNAMIC_MODAL_TYPES;
  id?: string;
} & Omit<ModalBodyProps, 'toggleClose'>;

const Modal: React.FC<ModalProps> = observer(
  ({
    visible,
    onClose = () => {},
    closeOnClickOutside = true,
    title,
    subtitle,
    children,
    showHeader = true,
    style,
    style_container,
    testID,
    isInstant = false,
    type,
    id,
  }) => {
    const {
      dynamicModal: { activeModal },
    } = useStore();
    const overlayRef = useRef(null);

    const onClickOutside = () => {
      if (closeOnClickOutside && id === activeModal.id) {
        onClose();
      }
    };
    useOnClickOutside(overlayRef, onClickOutside);

    const toggleClose = () => {
      onClose();
    };

    const ModalComponent = type === DYNAMIC_MODAL_TYPES.FullScreen ? ModalFullscreenContainer : ReactModal;

    return (
      <ModalComponent
        transparent
        visible={visible}
        animationType={isInstant ? 'none' : 'fade'}
        onRequestClose={toggleClose}
        onTouchCancel={toggleClose}
        testID={wrapperModalTestID(testID)}
      >
        <ModalBody
          ref={overlayRef}
          toggleClose={toggleClose}
          title={title}
          subtitle={subtitle}
          showHeader={showHeader}
          style={style}
          style_container={style_container}
          testID={testID}
        >
          {children}
        </ModalBody>
      </ModalComponent>
    );
  },
);

export default Modal;
